import React from "react";
import { IconProps } from "../icon";

export const AlignBottom_01Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 21h18M12 3v14m0 0l7-7m-7 7l-7-7"
    />
  </svg>
);
